import React from 'react';
import { Volume2, VolumeX, Droplets, ChevronLeft, ChevronRight, Film, Sparkles, Maximize, Minimize } from 'lucide-react';
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

export const Controls = ({ 
  isSoundOn, 
  toggleSound, 
  onPrevVideo,
  onNextVideo,
  showNavigation = false,
  useVideo = true,
  toggleMode,
  isFullscreen,
  toggleFullscreen
}) => {
  return (
    <TooltipProvider>
      <div className="controls-container">
        {/* Toggle Video/Animated mode - hidden */}

        {/* Previous video - only show if multiple videos */}
        {showNavigation && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button 
                className="control-btn"
                onClick={onPrevVideo}
                aria-label="Previous video"
              >
                <ChevronLeft size={22} />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Previous scene</p>
            </TooltipContent>
          </Tooltip>
        )}

        {/* Sound toggle */}
        <Tooltip>
          <TooltipTrigger asChild>
            <button 
              className={`control-btn ${isSoundOn ? 'active' : ''}`}
              onClick={toggleSound}
              aria-label={isSoundOn ? 'Mute sounds' : 'Play sounds'}
            >
              {isSoundOn ? <Volume2 size={22} /> : <VolumeX size={22} />}
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{isSoundOn ? 'Mute sounds' : 'Play sounds'}</p>
          </TooltipContent>
        </Tooltip>

        {/* Ripple indicator */}
        <Tooltip>
          <TooltipTrigger asChild>
            <button 
              className="control-btn active"
              aria-label="Click anywhere for ripples"
            >
              <Droplets size={22} />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Click anywhere for water ripples</p>
          </TooltipContent>
        </Tooltip>

        {/* Next video - only show if multiple videos */}
        {showNavigation && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button 
                className="control-btn"
                onClick={onNextVideo}
                aria-label="Next video"
              >
                <ChevronRight size={22} />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Next scene</p>
            </TooltipContent>
          </Tooltip>
        )}

        {/* Fullscreen toggle */}
        <Tooltip>
          <TooltipTrigger asChild>
            <button 
              className={`control-btn ${isFullscreen ? 'active' : ''}`}
              onClick={toggleFullscreen}
              aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            >
              {isFullscreen ? <Minimize size={22} /> : <Maximize size={22} />}
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};
